import { render, staticRenderFns } from "./common-metatag-list-item-code.vue?vue&type=template&id=b850e9b0&scoped=true&"
import script from "./common-metatag-list-item-code.vue?vue&type=script&lang=js&"
export * from "./common-metatag-list-item-code.vue?vue&type=script&lang=js&"
import style0 from "./common-metatag-list-item-code.vue?vue&type=style&index=0&id=b850e9b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850e9b0",
  null
  
)

export default component.exports